import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-rating-list',
  templateUrl: './rating-list.page.html',
  styleUrls: ['./rating-list.page.scss'],
})
export class RatingListPage implements OnInit {

  ratings: any[] = [];
  userId: number;
  averageRating: number = 0;
  userName: string = '';
  hasRatings: boolean = true;

  constructor(
    protected translate: TranslateService,
    private userService: UserService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.userService.getLoggedInUserId().subscribe({
      next: (id) => {
        this.userId = id;
        console.log('this.userId =', this.userId);
        this.fetchRatings(this.userId); // ✅ only call fetchRatings after we have userId
      },
      error: (err) => {
        console.error('Failed to get logged in user ID', err);
        this.hasRatings = false;
      }
    });
  }

  fetchRatings(userId: number): void {
    this.userService.getUserRatings(userId).subscribe({
      next: (response) => {
        this.ratings = response.ratings || [];
        this.userName = response.user;
        this.averageRating = response.average_rating;
        this.hasRatings = this.ratings.length > 0;
      },
      error: (err) => {
        console.error('Error fetching ratings:', err);
        this.ratings = [];
        this.hasRatings = false;
      }
    });
  }
}
